import { selectModels } from "domain/models";
import { useMemo } from "react";
import * as staticDataService from "services/staticDataService";

export const CLASSIFICATIONS_CONFIG_KEY = "classifications";

// The pricing models from `classifications.models`, with the defaults while
// nothing is configured. `isLoading` is true until the config has been read.
export const useModels = () => {
  const { data, isLoading } = staticDataService.useConfigQuery(
    CLASSIFICATIONS_CONFIG_KEY
  );
  const models = useMemo(() => selectModels(data), [data]);
  return { models, isLoading: !!isLoading };
};
